import React, { useState } from "react";
import { Layout, Row, Col, Drawer, Menu, Button, Grid } from "antd";
import { Link, useLocation } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";
import moment from "moment";
import { Div } from "./style";
import AuthInfo from "../components/utilities/auth-info/info";
import TopMenu from "./TopMenu";
import { menuConfig } from "../utility/menuList";

const { Header, Footer, Content } = Layout;
const { useBreakpoint } = Grid;

const ThemeLayout = (WrappedComponent) => {
    return function LayoutComponent(props) {
        const darkMode = false;
        const screens = useBreakpoint();
        const isMobile = !screens.md; // mobile/tablet mode when screen width < 768px
        const location = useLocation();
        const [drawerVisible, setDrawerVisible] = useState(false);

        // Match current route to find key
        const matchedKey = menuConfig.customer_care.find(item => 
            location.pathname.toLowerCase().startsWith('/' + item.key)
        )?.key || 'dashboard';

        return (
            <Div darkMode={darkMode}>
                <Layout className="layout">
                    <Header style={{ padding: '0 16px', height: '64px', display: 'flex', alignItems: 'center' }}>
                        <Row align="middle" justify="space-between" style={{ width: '100%', height: '100%', margin: 0 }}>
                            {isMobile ? (
                                <>
                                    <Col xs={16} style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                        <Button 
                                            type="text" 
                                            icon={<MenuOutlined style={{ color: '#fff', fontSize: '20px' }} />} 
                                            onClick={() => setDrawerVisible(true)}
                                            style={{ 
                                                padding: 0, 
                                                width: '40px', 
                                                height: '40px', 
                                                display: 'flex', 
                                                alignItems: 'center', 
                                                justifyContent: 'center',
                                                background: 'transparent'
                                            }}
                                        />
                                        <div className="logo">
                                            <Link to="/" style={{ display: 'flex', alignItems: 'center' }}>
                                                <img
                                                    src={require(`../static/img/logo.png`)}
                                                    alt="logo"
                                                    style={{ height: '24px', objectFit: 'contain' }}
                                                />
                                            </Link>
                                        </div>
                                    </Col>
                                    <Col xs={8} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                        <AuthInfo darkMode={darkMode} />
                                    </Col>
                                </>
                            ) : (
                                <>
                                    <Col xxl={4} lg={4} md={5} sm={6} xs={6} style={{ display: 'flex', alignItems: 'center' }}>
                                        <div className="logo">
                                            <Link to="/" style={{ display: 'flex', alignItems: 'center' }}>
                                                <img
                                                    src={require(`../static/img/logo.png`)}
                                                    alt="logo"
                                                    style={{ height: '32px', objectFit: 'contain' }}
                                                />
                                            </Link>
                                        </div>
                                    </Col>
                                    <Col xxl={15} lg={15} md={15} sm={10} xs={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <TopMenu darkMode={darkMode} />
                                    </Col>
                                    <Col xxl={5} lg={5} md={4} sm={8} xs={6} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                        <AuthInfo darkMode={darkMode} />
                                    </Col>
                                </>
                            )}
                        </Row>
                    </Header>
                    <Layout>
                        <Layout hasSider>
                            <Content style={{ minHeight: 'calc(100vh - 128px)' }}>
                                <WrappedComponent {...props} />
                            </Content>
                        </Layout>
                    </Layout>
                    <Footer className="admin-footer" style={{ padding: "20px 30px", textAlign: 'right' }}>
                        <span>
                            2018 - {moment().format("YYYY")} © <Link to="https://www.skilledanswers.com/">SkilledAnswers Info Solutions Pvt Ltd</Link>
                        </span>
                    </Footer>
                </Layout>

                {/* Mobile Navigation Drawer */}
                <Drawer
                    title={
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <img 
                                src={require(`../static/img/logo.png`)} 
                                alt="logo" 
                                style={{ height: '24px', objectFit: 'contain' }} 
                            />
                        </div>
                    }
                    placement="left"
                    closable={true}
                    onClose={() => setDrawerVisible(false)}
                    visible={drawerVisible}
                    bodyStyle={{ padding: 0 }}
                    width={280}
                >
                    <Menu
                        mode="inline"
                        selectedKeys={[matchedKey]}
                        onClick={() => setDrawerVisible(false)}
                        style={{ borderRight: 0 }}
                    >
                        {menuConfig.customer_care.map(item => (
                            <Menu.Item key={item.key} icon={item.icon}>
                                {item.label}
                            </Menu.Item>
                        ))}
                    </Menu>
                </Drawer>
            </Div>
        );
    };
};

export default ThemeLayout;
